import { render, staticRenderFns } from "./ctree.vue?vue&type=template&id=28390728&scoped=true"
import script from "./ctree.vue?vue&type=script&lang=js"
export * from "./ctree.vue?vue&type=script&lang=js"
import style0 from "./ctree.vue?vue&type=style&index=0&id=28390728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28390728",
  null
  
)

export default component.exports